import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { Button, FormHelperText, Box } from "@mui/material";
const ThankYouPage = () => {
  return (
    <Box sx={{ height: 100,marginBottom:"100px" }}>
      <FormHelperText sx={{fontSize: "18px", }}>
        <Trans i18nKey="global:thankyou_message" />
      </FormHelperText>
    </Box>
  );
};

export default ThankYouPage;
